import { render, staticRenderFns } from "./Paymentmethods.vue?vue&type=template&id=0237a1b7"
import script from "./Paymentmethods.vue?vue&type=script&lang=js"
export * from "./Paymentmethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports